import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { authApi } from "../../services/authApi";

import "../styles/auth.css";

export default function OnboardingLanding() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const qs = new URLSearchParams(window.location.search);
    const e = qs.get("email");
    if (e) setEmail(e);
  }, []);

  const handleContinue = async () => {
    const value = email.trim().toLowerCase();
    if (!value) return alert("Enter your email");

    setLoading(true);
    try {
      const data = await authApi.bootstrapTeledoctor(value);
          sessionStorage.setItem("onb_sessionToken", data.sessionToken);
          sessionStorage.setItem("onb_userId", data.userId);
          sessionStorage.setItem("onb_email", value);

      nav("/onboarding/phone");
    } catch (e: any) {
      alert(e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-wrap">
      <div className="auth-topbar">
        <div style={{ fontWeight: 800, color: "#174350" }}>QAVACH</div>
        <div style={{ color: "#777" }}>TeleDoctor Onboarding</div>
      </div>

      <div className="auth-accent">
        Fortifying Health, Prioritizing Prevention, Promoting Wellness
      </div>

      <div className="auth-card">
        <h2 className="auth-title">Email Verified ✅</h2>
        <p className="auth-sub">
          Enter the same email you used for the invite to continue onboarding.
        </p>

        <input
          className="auth-input"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="doctor@example.com"
        />

        <button className="auth-btn" disabled={loading} onClick={handleContinue}>
          {loading ? "Checking..." : "Continue"}
        </button>
      </div>
    </div>
  );
}
